import React, { useState, useEffect, useRef } from "react";
import { useForm,Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import PageHeader from "../components/PageHeader";
import { dropdownData } from "../data/ecce_dropdowndata";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import ECCEDATA from '../data/ecce_data.json'
import { schemas } from "../config/yupvalidation";
import { toBase64 } from "../config/apiUrls";
import { isMobile } from "react-device-detect";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";

const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    border: "1px solid #ced4da",
    boxShadow: 'none',
    '&:hover': {
      border: "1px solid #ced4da",
    },

    minHeight: "38px",
    fontSize: "14px",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#212529",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#212529",
  }),
}

const ECCAMultiStepForm = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [isFromFill,setIsFromFill] = useState(false)
  const [stepValidation, setStepValidation] = useState([]);
  const [formData, setFormData] = useState({});
  const [storeUserId,setStoreUserId]= useState(null)
  const [loadingStep,setLoadingStep] = useState(false)
  const [options, setOptions] = useState([]);
  const [selectedOptionmonth, setSelectedOptionmonth] = useState(null);
  const [formSubmited,setFormSubmited] = useState(false);
  const [isChange,setIsChange] = useState(false)
  const [isEditing,setisEditing] = useState(false)
  const stepRefs = useRef([]);
  const [documents, setDocuments] = useState({
    highestQualificationMarksheet: "",
    aadhaarCard: "",
    photo: "",
  });
  const [changeDoc,setChangeDoc]= useState({
    highestQualificationMarksheet: false,
    aadhaarCard: false,
    photo: false,
  })
  const [fileErrors, setFileErrors] = useState({
    highestQualificationMarksheet: "",
    aadhaarCard: "",
    photo: "",
  });
  const hasFileErrors = () => {
    return Object.values(fileErrors).some((err) => err !== "");
  };

  const [apiError,setApiError]= useState({})
  const LMS = process.env.REACT_APP_API_LMS;
  const token = process.env.REACT_APP_API_TOKEN;
  const studentID= sessionStorage.getItem("id")

  const { register, handleSubmit,setValue,control, formState: { errors }, watch, reset } = useForm({
    resolver: yupResolver(schemas[currentStep]),
    mode: "onBlur",
    context: {
      skipDobValidation:
        !!formData?.months_of_experience && !!formData?.date_of_birth,
      skipExperienceValidation: !!formData?.months_of_experience,
    },
    defaultValues: {
        firstName:sessionStorage.getItem("first_name"),
        lastName:sessionStorage.getItem("last_name"),
        fatherLastName:sessionStorage.getItem("last_name"),
        motherLastName:sessionStorage.getItem("last_name"),
        email: sessionStorage.getItem("email"),
        dateOfBirth: formData?.dateOfBirth
        ? dayjs(formData.dateOfBirth, "DD-MM-YYYY").toDate()
        : null,
        trainingStatus: "Experienced",
        previousExperienceSector:formData?.previous_experience_sector ? formData?.previous_experience_sector :'IT',
        months_of_experience:formData?.months_of_experience ? formData?.months_of_experience : 0
    },
  });

  async function setpWisePatch(url, bodyData) {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
        method: "PATCH",
        headers: myHeaders,
        body: JSON.stringify(bodyData),
        redirect: "follow",
    };

    try {
        const response = await fetch(url, requestOptions);
        const result = await response.json(); // ✅ Must read body first

        if (!response.ok) {
            throw { message: result.message, errors: result.errors };
        }
        return result;

    } catch (error) {
        console.error("Error:", error);
        throw error;
    }
  }

  const submitStudentAdmission = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Accept", "application/json");

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: "",
        redirect: "follow",
      };

      const response = await fetch(
        `${LMS}/api/student-admission/${storeUserId}/submit`,
        requestOptions
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Error submitting student admission:", error);
      throw error;
    }
  };

  useEffect(() => {
    if (formData?.months_of_experience) {
      const exists = options.some(opt => opt.value === formData.months_of_experience);
      const newOption = { 
        label: `${formData.months_of_experience} Months`, 
        value: formData.months_of_experience 
      };

      if (!exists) {
        setOptions(prev => [...prev, newOption]);
      }
      
      setValue("monthsOfExperience", formData?.months_of_experience, {
        shouldValidate: false,
      });
      setValue("previousExperienceSector",formData?.previous_experience_sector ? formData?.previous_experience_sector:'IT')
      setSelectedOptionmonth(newOption);
    }
  }, [formData?.months_of_experience]);
    
  useEffect(() => {
    if (window.innerWidth <= 768 && stepRefs.current[currentStep]) {
      stepRefs.current[currentStep].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [currentStep]);

  const fetchStudentData = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Accept", "application/json");

      const response = await fetch(`${LMS}/api/student-admission/${studentID}`, {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      });

      if (!response.ok) throw new Error("Failed to fetch student data");
      const result = await response.json();
      if (result?.status && result.data) {
        const d = result.data;
        if(d.email_id){
          setisEditing(true)
        }
        // if(d.email_id || d.country_code || d.mobile_no || d.date_of_birth){
        //   setisEditing(true)
        // }

        const mappedData = {
          salutation: d.salutation || "",
          firstName: d.first_name || "",
          middleName: d.middle_name || "",
          lastName: d.last_name || "",
          gender: d.gender || "",
          dateOfBirth:  d.date_of_birth || "",
          maritalStatus: d.marital_status || "",
          fatherFirstName: d.father_first_name || "",
          fatherLastName: d.father_last_name || "",
          motherFirstName: d.mother_first_name || "",
          motherLastName: d.mother_last_name || "",
          religion: d.religion || "",
          category: d.category || "",
          disability: d.disability || "",
          typeOfDisability: d.type_of_disability || "",
          domicileState: d.domicile_state || "",
          domicileDistrict: d.domicile_district || "",
          idType: d.id_type || "",
          alternateIdType: d.type_of_alternate_id || "",
          idNo: d.id_no || "",
          email: d.email_id || "",
          countryCode: d.country_code || "",
          mobile: d.mobile_no || "",
          permanentAddress: d.permanent_address || "",
          permanentState: d.permanent_address_state || "",
          permanentDistrict: d.permanent_address_district || "",
          permanentPin: d.permanent_address_pin_code || "",
          permanentConstituency: d.permanent_address_constituency || "",
          permanentCity:d.permanent_address_city|| "",
          permanentTehsil:d.permanent_address_tehsil || "",
          communicationSame: d.communication_same_as_permanent || "Yes",
          communicationState:d.communication_address_state || '',
          communicationDistrict:d.communication_address_district,
          communicationPin:d.communication_address_pin_code || "",
          communicationCity:d.communication_address_city || "",
          communicationTehsil:d.communication_address_tehsil || "",
          communicationConstituency:d.communication_address_constituency || "",
          educationLevel: d.education_level || "",
          trainingStatus: 'Experienced' || "Experienced",
          employed: d.employed || "",
          employmentStatus: d.employment_status || "",
          employmentDetails: d.employment_details || "",
          heardAboutUs: d.heard_about_us || "",
          previousExperienceSector:d.previous_experience_sector || '',
          months_of_experience:d.months_of_experience || 0,
          highest_qualification_marksheet:d.highest_qualification_marksheet || null,
          aadhaar_card:d.aadhaar_card || null,
          photo:d.photo|| null,
          form_stage:d.form_stage
        };

        setFormData(mappedData);
        if(d.student_id ==studentID){
          setisEditing(true)
        }
        const stepIndex = d.form_stage - 1; 
        setCurrentStep(stepIndex);
        setIsFromFill(d.form_stage == 7 ? true: false)
        let validationArray;
        if (d.form_stage >= steps.length) {
          validationArray = steps.map(() => true);
        } else {
          validationArray = steps.map((_, index) => index < stepIndex);
        }
        setStepValidation(validationArray);
        setStoreUserId(d?.id)
        reset(mappedData);
      }
    } catch (error) {
      console.error("Error fetching student data:", error);
    }
  };
  useEffect(() => {
    fetchStudentData();
  }, [LMS, token, reset]);

  useEffect(() => {
    reset(formData);
  }, [currentStep]);

  const watchDisability = watch("disability");
  const watchIdType = watch("idType");
  const watchCommunicationSame = watch("communicationSame");
  const watchTrainingStatus = watch("trainingStatus");

  const steps = [
    "Personal Details",
    "Identification Details",
    "Contact Details",
    "Address",
    "Education & Experience",
    "Employment Details",
    "Other / Document"
  ];

  const onSubmit = async (data) => {
    const updatedData = { ...formData, ...data };
    setFormData(updatedData);

    if (currentStep === 0) {
      const payload = {
        salutation: updatedData.salutation,
        first_name: updatedData.firstName,
        middle_name: updatedData.middleName,
        last_name: updatedData.lastName,
        gender: updatedData.gender,
        date_of_birth:  updatedData.dateOfBirth
        ? typeof updatedData.dateOfBirth === "string"
          ? dayjs(updatedData.dateOfBirth, "DD-MM-YYYY").format("DD-MM-YYYY")
          : dayjs(updatedData.dateOfBirth).format("DD-MM-YYYY")
        : null,
        marital_status: updatedData.maritalStatus,
        father_first_name: updatedData.fatherFirstName,
        father_last_name: updatedData.fatherLastName,
        mother_first_name: updatedData.motherFirstName,
        mother_last_name: updatedData.motherLastName,
        religion: updatedData.religion,
        category: updatedData.category,
        disability: updatedData.disability,
        type_of_disability: updatedData.typeOfDisability ? updatedData.typeOfDisability:null,
        domicile_state: updatedData.domicileState,
        domicile_district: updatedData.domicileDistrict,
        ...(isEditing ? {} : { student_id: studentID })
      };
      if(isEditing){
        setLoadingStep(true)
        const apiUrl = `${LMS}/api/student-admission/${storeUserId}/step/1`;
        setpWisePatch(apiUrl, payload)
        .then(data => {
            setCurrentStep(currentStep + 1);
        })
        .catch(err => {}).finally(()=>{
            setLoadingStep(false)
        })
      }else{
        try {
            setLoadingStep(true)
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Accept", "application/json");
            myHeaders.append("Content-Type", "application/json");

            const response = await fetch(`${LMS}/api/student-admission`,{ 
                    method: "POST",
                    headers: myHeaders,
                    body: JSON.stringify(payload),
                }
            );

            const result = await response.json();
            setApiError(result?.errors)
            console.log("API Response:", result);

            if (!response.ok) {
                throw new Error(result.message || "API request failed");
            }
            setStoreUserId(result?.data.id)
            setCurrentStep(currentStep + 1);

        } catch (error) {
            // Swal.fire({
            //     icon: "error",
            //     text:"Validation Errors",
            //     confirmButtonText: "OK",
            //     width: 600,
            // });
        }finally{
          setLoadingStep(false)
        }
      }
    }
    if(currentStep === 1){
        setLoadingStep(true)
        const apiUrl = `${LMS}/api/student-admission/${storeUserId}/step/2`;
        const requestBody = {
            id_type: updatedData?.idType,
            type_of_alternate_id: updatedData.alternateIdType,
            aadhar_reference_no: null,
            id_no: updatedData.idNo
        };
        setpWisePatch(apiUrl, requestBody)
        .then(data => {
            setCurrentStep(currentStep + 1);
        })
        .catch(err => {
          setApiError(err?.errors)
        }).finally(()=>{
            setLoadingStep(false)
        })
    }
    if(currentStep === 2){
        if(isEditing){
           setCurrentStep(currentStep + 1);
           return
        }
        setLoadingStep(true)
        const apiUrl = `${LMS}/api/student-admission/${storeUserId}/step/3`;
        const requestBody = {
            "email_id": updatedData?.email,
            "country_code": updatedData?.countryCode,
            "mobile_no": updatedData?.mobile
        };
        setpWisePatch(apiUrl, requestBody)
        .then(data => {
            setCurrentStep(currentStep + 1);
        })
        .catch(err => {}).finally(()=>{
            setLoadingStep(false)
        })
    }
    if(currentStep === 3){
        setLoadingStep(true)
        const apiUrl = `${LMS}/api/student-admission/${storeUserId}/step/4`;
        const requestBody = {
            "permanent_address": updatedData?.permanentAddress,
            "permanent_address_state":updatedData.permanentState,
            "permanent_address_district": updatedData.permanentDistrict,
            "permanent_address_pin_code": updatedData.permanentPin,
            "permanent_address_city": updatedData.permanentCity,
            "permanent_address_tehsil": updatedData.permanentTehsil,
            "permanent_address_constituency": updatedData.permanentConstituency,
            "communication_same_as_permanent": updatedData?.communicationSame,
            "communication_address_state": updatedData?.communicationSame== 'Yes' ? updatedData?.permanentState  : updatedData.communicationState,
            "communication_address_district": updatedData?.communicationSame== 'Yes' ? updatedData.permanentDistrict:updatedData.communicationDistrict,
            "communication_address_pin_code": updatedData?.communicationSame== 'Yes' ? updatedData.permanentPin:updatedData.communicationPin,
            "communication_address_city": updatedData?.communicationSame== 'Yes' ? updatedData.permanentCity:updatedData.communicationCity,
            "communication_address_tehsil": updatedData?.communicationSame== 'Yes' ? updatedData.permanentTehsil:updatedData.communicationTehsil,
            "communication_address_constituency": updatedData?.communicationSame== 'Yes' ? updatedData.permanentConstituency:updatedData.communicationConstituency
        };
        setpWisePatch(apiUrl, requestBody)
        .then(data => {
            setCurrentStep(currentStep + 1);
        })
        .catch(err => {
          setApiError(err?.errors)
        }).finally(()=>{
            setLoadingStep(false)
        });
    }
    if(currentStep === 4){
        setLoadingStep(true)
        const apiUrl = `${LMS}/api/student-admission/${storeUserId}/step/5`;
        const requestBody = {
            "education_level": updatedData?.educationLevel,
            "training_status": "Experienced", //always experienced
            "previous_experience_sector": updatedData?.previousExperienceSector,   // <-- mandatory now
            "months_of_experience":isChange ? updatedData?.monthsOfExperience: formData?.months_of_experience ? formData?.months_of_experience : updatedData?.monthsOfExperience
        }
        setpWisePatch(apiUrl, requestBody)
        .then(data => {
            setCurrentStep(currentStep + 1);
            setIsChange(false)
        })
        .catch(err => {
          setApiError(err?.errors)
        }).finally(()=>{
            setLoadingStep(false)
        });
    }
    if(currentStep === 5){
        setLoadingStep(true)
        const apiUrl = `${LMS}/api/student-admission/${storeUserId}/step/6`;
        const requestBody = {
            "employed": updatedData?.employed,
            "employment_status": updatedData.employmentStatus,
            "employment_details": updatedData.employmentDetails
        }
        setpWisePatch(apiUrl, requestBody)
        .then(data => {
            setApiError({})
            setCurrentStep(currentStep + 1);
        })
        .catch(err => {
          setApiError(err?.errors)
        }).finally(()=>{
            setLoadingStep(false)
        });
    }
    if(currentStep === 6){
        if (hasFileErrors()) {
          Swal.fire({
            icon:"error",
            text:"Please check the file size"
          })
          return;
        }
        setLoadingStep(true)
        const apiUrl = `${LMS}/api/student-admission/${storeUserId}/step/7`;
        const requestBody = {
          heard_about_us: updatedData.heardAboutUs,
          highest_qualification_marksheet: changeDoc.highestQualificationMarksheet
            ? documents.highestQualificationMarksheet
            : formData?.highest_qualification_marksheet,
          aadhaar_card: changeDoc.aadhaarCard
            ? documents.aadhaarCard
            : formData?.aadhaar_card,
          photo: changeDoc.photo
            ? documents.photo
            : formData?.photo,
        };
        setpWisePatch(apiUrl, requestBody)
        .then(async data => {
            setFormSubmited(true)
            if(data.status==true){
              setApiError({})
              setLoadingStep(false)
              const resultSwal = await Swal.fire({
                icon:"success",
                html:`<div className="card shadow-lg text-center p-4">
                <div className="card-body">
                <h4 className="card-title mb-2 text-success">Form Submitted Successfully!</h4>
                <p className="card-text text-muted">
                Thank you for submitting your details.
                </p>
                </div>
                </div>
                `})
                if(resultSwal.isConfirmed){
                  submitStudentAdmission()
                  fetchStudentData()
                  setFormSubmited(false)
                  setChangeDoc({
                    highestQualificationMarksheet: false,
                    aadhaarCard: false,
                    photo: false,
                  });
                }
            }
        })
        .catch(err => {
          setApiError(err?.errors)
        }).finally(()=>{
            setLoadingStep(false)
        });
    }
  };

  const handleInputChange = (inputValue) => {
    setIsChange(true)
    const num = parseFloat(inputValue);
    if (!isNaN(num) && num > 0) {
        const isDecimal = inputValue.includes(".");

        const months = Math.round(num * 12);
        const newOptions = [{ value: num, label: `${num} Months` }];

        if (isDecimal) {
        newOptions.push({
            value: months,
            label: `${num} Years (~${months} Months)`
        });
        }

        setOptions(newOptions);
    } else {
        setOptions([]);
    }
  };

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      setValue("monthsOfExperience", selectedOption.value);
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  // const getStepStatus = (index) => {
  //   if (index < currentStep) return "completed";
  //   if (index === currentStep && isFromFill) return "completed";
  //   if (index === currentStep) return "active";
  //   return "pending";
  // };
  const getStepStatus = (index) => {
    if (isFromFill) {
      return index === currentStep ? "active" : "completed";
    }

    // Normal flow (form not fully filled)
    if (index < currentStep) return "completed";
    if (index === currentStep) return "active";
    return "pending";
  };

  const handleStepClick = (index) => {
    if (isFromFill) {
      setCurrentStep(index);
      return;
    }
    const isClickable = index <= currentStep || (index === currentStep + 1 && stepValidation[currentStep]);
    if (isClickable) setCurrentStep(index);
  };

  return (
    <div>
        <div className="row">
            <div className="col-12">
                <PageHeader title="ECCE Form" 
                    breadcrumbs={[
                    { label: "Dashboard", path: "/dashboard" },
                    { label: "ECCA Form", active: true }
                    ]}
                />
            </div>
        </div>
        <div className="card shadow">
            <div className="card-body">
            <div className="mb-4">
              <div className="step-scroll-container">
                <div className="d-flex justify-content-between mb-2 ">
                    {steps.map((step, index) => {
                      const status = getStepStatus(index);
                      const isClickable = isFromFill
                        ? true
                        : index <= currentStep || (index === currentStep + 1 && stepValidation[currentStep]);

                      return(
                          <div
                            key={index}
                            ref={(el) => (stepRefs.current[index] = el)} 
                            className={`text-center flex-fill ${isFromFill && currentStep === index ? "ecceactive" : "ecceactive1"}`}
                          >
                            <div className="d-inline-flex align-items-center justify-content-center">
                              <div
                                className={`step-circle ${status} ${!isClickable ? "disabled" : ""}`}
                                onClick={() => isClickable && handleStepClick(index)}
                                title={`Step ${index + 1}: ${step}`}
                                style={{ cursor: isClickable ? "pointer" : "not-allowed" }}
                              >
                                {status === "completed" ? <i className="bi bi-check"></i> : index + 1}
                              </div>
                            </div>
                            <div className={`mt-1 small ${status === "completed" ? "fw-bold text-success" : ""}`}>
                              {step}
                            </div>
                          </div>
                      )
                    })}
                </div>
              </div>
              <div className="progress" style={{ height: '4px' }}>
                <div
                  className="progress-bar bg-success"
                  style={{
                    width: isFromFill
                      ? "100%" 
                      : `${((currentStep + 1) / steps.length) * 100}%`,
                    transition: "width 0.3s ease",
                  }}
                ></div>
              </div>
            </div>

            <h4 className="mb-4 text-primary">{steps[currentStep]}</h4>
            <form onSubmit={handleSubmit(onSubmit)}>
                {currentStep === 0 && (
                <div className="row g-3">
                    <div className="col-md-3">
                        <label className="form-label">Salutation <span className="text-danger">*</span></label>
                        <select className="form-select" {...register("salutation")}>
                            <option value="">Select</option>
                            {dropdownData.salutations.map(s => <option key={s} value={s}>{s}</option>)}
                        </select>
                        {errors.salutation && <small className="text-danger">{errors.salutation.message}</small>}
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">First Name <span className="text-danger">*</span></label>
                        <input type="text" maxLength={50} className="form-control" {...register("firstName")} />
                        {errors.firstName && <small className="text-danger">{errors.firstName.message}</small>}
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">Middle Name <span className="text-danger">*</span></label>
                        <input type="text" maxLength={50}  className="form-control" {...register("middleName")} />
                        {errors.middleName && <small className="text-danger">{errors.middleName.message}</small>}
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">Last Name <span className="text-danger">*</span></label>
                        <input type="text" maxLength={50}  className="form-control" {...register("lastName")} />
                        {errors.lastName && <small className="text-danger">{errors.lastName.message}</small>}
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">Gender <span className="text-danger">*</span></label>
                        <select className="form-select" {...register("gender")}>
                            <option value="">Select</option>
                            {dropdownData.genders.map(g => <option key={g} value={g}>{g}</option>)}
                        </select>
                        {errors.gender && <small className="text-danger">{errors.gender.message}</small>}
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">Date of Birth <span className="text-danger">*</span></label>
                        <Controller
                          control={control}
                          name="dateOfBirth"
                          render={({ field }) => {
                            let parsedDate = null;
                            if (typeof field.value === "string" && field.value.includes("-")) {
                              const [day, month, year] = field.value.split("-").map(Number);
                              parsedDate = new Date(year, month - 1, day);
                              if (isNaN(parsedDate.getTime())) parsedDate = null;
                            } else if (field.value instanceof Date) {
                              parsedDate = field.value;
                            }
                            return (
                              <DatePicker
                                selected={parsedDate}
                                onChange={(date) => field.onChange(date)}
                                placeholderText="Select DOB: DD-MM-YYYY"
                                dateFormat="dd-MM-yyyy"
                                maxDate={new Date()}
                                showYearDropdown
                                scrollableYearDropdown
                                yearDropdownItemNumber={100}
                                wrapperClassName="w-100 text-dark"
                                className="form-control datepickerheight text-dark"
                              />
                            );
                          }}
                        />

                        {apiError?.date_of_birth?.length > 0 && (
                          <small className="text-danger">{apiError.date_of_birth[0]}</small>
                        )}
                        {/* {errors.dateOfBirth && (<small className="text-danger">{errors.dateOfBirth.message}</small>)} */}
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">Marital Status <span className="text-danger">*</span></label>
                        <select className="form-select" {...register("maritalStatus")}>
                            <option value="">Select</option>
                            {dropdownData.maritalStatuses.map(m => <option key={m} value={m}>{m}</option>)}
                        </select>
                        {errors.maritalStatus && <small className="text-danger">{errors.maritalStatus.message}</small>}
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">Category <span className="text-danger">*</span></label>
                        <select className="form-select" {...register("category")}>
                            <option value="">Select</option>
                            {dropdownData.categories.map(c => <option key={c} value={c}>{c}</option>)}
                        </select>
                        {errors.category && <small className="text-danger">{errors.category.message}</small>}
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">Father's First Name <span className="text-danger">*</span></label>
                        <input type="text" maxLength={50}  className="form-control" {...register("fatherFirstName")} />
                        {errors.fatherFirstName && <small className="text-danger">{errors.fatherFirstName.message}</small>}
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">Father's Last Name <span className="text-danger">*</span></label>
                        <input type="text" maxLength={50}  className="form-control" {...register("fatherLastName")} />
                        {errors.fatherLastName && <small className="text-danger">{errors.fatherLastName.message}</small>}
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">Mother's First Name <span className="text-danger">*</span></label>
                        <input type="text" maxLength={50}  className="form-control" {...register("motherFirstName")} />
                        {errors.motherFirstName && <small className="text-danger">{errors.motherFirstName.message}</small>}
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">Mother's Last Name <span className="text-danger">*</span></label>
                        <input type="text" maxLength={50}  className="form-control" {...register("motherLastName")} />
                        {errors.motherLastName && <small className="text-danger">{errors.motherLastName.message}</small>}
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">Religion <span className="text-danger">*</span></label>
                        <select className="form-select" {...register("religion")}>
                            <option value="">Select</option>
                            {dropdownData.religions.map(r => <option key={r} value={r}>{r}</option>)}
                        </select>
                        {errors.religion && <small className="text-danger">{errors.religion.message}</small>}
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">Disability <span className="text-danger">*</span></label>
                        <select className="form-select" {...register("disability")}>
                            <option value="">Select</option>
                            {dropdownData.disabilities.map(d => <option key={d} value={d}>{d}</option>)}
                        </select>
                        {errors.disability && <small className="text-danger">{errors.disability.message}</small>}
                    </div>

                    {watchDisability === "Yes" && (
                    <div className="col-md-3">
                        <label className="form-label">Type of Disability <span className="text-danger">*</span></label>
                        <select className="form-select" {...register("typeOfDisability")}>
                        <option value="">Select</option>
                        {dropdownData.disabilityTypes.map(dt => <option key={dt} value={dt}>{dt}</option>)}
                        </select>
                        {errors.typeOfDisability && <small className="text-danger">{errors.typeOfDisability.message}</small>}
                    </div>
                    )}

                    <div className="col-md-3">
                        <label className="form-label">Domicile State <span className="text-danger">*</span></label>
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          styles={customSelectStyles}
                          options={Object.keys(ECCEDATA.domecile_states).map((state) => ({
                            value: state,
                            label: state,
                          }))}
                          placeholder="Select State"
                          value={
                            watch("domicileState")
                              ? { value: watch("domicileState"), label: watch("domicileState") }
                              : null
                          }
                          onChange={(selectedOption) => {
                            const selectedState = selectedOption ? selectedOption.value : "";
                            setValue("domicileState", selectedState);
                            setValue("domicileDistrict", "");
                          }}
                          components={{IndicatorSeparator: () => null }}
                        />
                        {errors.domicileState && <small className="text-danger">{errors.domicileState.message}</small>}
                    </div>

                    <div className="col-md-3">
                    <label className="form-label">Domicile District <span className="text-danger">*</span></label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      // styles={customSelectStyles}
                      styles={{
                        ...customSelectStyles,
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                        menuList: (provided) => ({
                          ...provided,
                        }),
                      }}
                      placeholder={
                        watch("domicileState")
                          ? "Select District"
                          : "Select State First"
                      }
                      isDisabled={!watch("domicileState")}
                      options={
                        watch("domicileState")
                          ? ECCEDATA.domecile_states[watch("domicileState")].map((d) => ({
                              value: d,
                              label: d,
                            }))
                          : []
                      }
                      value={
                        watch("domicileDistrict")
                          ? {
                              value: watch("domicileDistrict"),
                              label: watch("domicileDistrict"),
                            }
                          : null
                      }
                      onChange={(selectedOption) => {
                        const selectedDistrict = selectedOption ? selectedOption.value : "";
                        setValue("domicileDistrict", selectedDistrict);
                      }}
                      components={{IndicatorSeparator: () => null }}
                    />
                    {errors.domicileDistrict && <small className="text-danger">{errors.domicileDistrict.message}</small>}
                    </div>
                </div>
                )}

                {/* Step 2: Identification Details */}
                {currentStep === 1 && (
                <div className="row g-3">
                    <div className="col-md-4">
                    <label className="form-label">ID Type <span className="text-danger">*</span></label>
                    <select className="form-select" {...register("idType")}>
                        <option value="">Select</option>
                        {dropdownData.idTypes.map(id => <option key={id} value={id}>{id}</option>)}
                    </select>
                    {errors.idType && <small className="text-danger">{errors.idType.message}</small>}
                    </div>

                    <div className="col-md-4">
                    <label className="form-label">Type of Alternate ID <span className="text-danger">*</span></label>
                    <select className="form-select" {...register("alternateIdType")}>
                        <option value="">Select</option>
                        {dropdownData.alternateIdTypes.map(alt => <option key={alt} value={alt}>{alt}</option>)}
                    </select>
                    {errors.alternateIdType && <small className="text-danger">{errors.alternateIdType.message}</small>}
                    </div>

                    <div className="col-md-4">
                    <label className="form-label">Aadhar No. <span className="text-danger">*</span></label>
                    <input type="text" maxLength={12} className="form-control" {...register("idNo")} />
                    {errors.idNo && <small className="text-danger">Aadhar no. must be 12 number with no space or special characters</small>}
                    </div>
                </div>
                )}

                {/* Step 3: Contact Details */}
                {currentStep === 2 && (
                <div className="row g-3">
                    <div className="col-md-4">
                        <label className="form-label">Email ID <span className="text-danger">*</span></label>
                        <input type="email" maxLength={50} disabled={isEditing} className="form-control" {...register("email")} placeholder="example@gmail.com" />
                        {errors.email && <small className="text-danger">{errors.email.message}</small>}
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">Country Code <span className="text-danger">*</span></label>
                        <select className="form-select" {...register("countryCode")}>
                            <option value="">Select</option>
                            {dropdownData.countryCodes.map(cc => <option key={cc} value={cc}>{cc}</option>)}
                        </select>
                        {errors.countryCode && <small className="text-danger">{errors.countryCode.message}</small>}
                    </div>

                    <div className="col-md-5">
                        <label className="form-label">Mobile No <span className="text-danger">*</span></label>
                        <input type="tel" maxLength={10} className="form-control" {...register("mobile")} placeholder="10 digit number" />
                        {errors.mobile && <small className="text-danger">{errors.mobile.message}</small>}
                    </div>
                </div>
                )}

                {/* Step 4: Address */}
                {currentStep === 3 && (
                <div className="row g-3">
                    <div className="col-12">
                    <h5 className="text-secondary mb-3">Permanent Address</h5>
                    </div>

                    <div className="col-md-12">
                        <label className="form-label">Address <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" {...register("permanentAddress")} />
                        {errors.permanentAddress && <small className="text-danger">{errors.permanentAddress.message}</small>}
                        {apiError?.permanent_address?.length > 0 && (
                          <small className="text-danger">{apiError.permanent_address[0]}</small>
                        )}
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">State <span className="text-danger">*</span></label>
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          styles={customSelectStyles}
                          options={Object.keys(ECCEDATA.domecile_states).map((state) => ({
                            value: state,
                            label: state,
                          }))}
                          placeholder="Select State"
                          value={
                            watch("permanentState")
                              ? { value: watch("permanentState"), label: watch("permanentState") }
                              : null
                          }
                          onChange={(selectedOption) => {
                            const selectedState = selectedOption ? selectedOption.value : "";
                            setValue("permanentState", selectedState);
                            setValue("permanentDistrict", "");
                          }}
                          components={{IndicatorSeparator: () => null }}
                        />
                        {errors.permanentState && <small className="text-danger">{errors.permanentState.message}</small>}
                    </div>

                    <div className="col-md-3">
                    <label className="form-label">District <span className="text-danger">*</span></label>
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          styles={customSelectStyles}
                          placeholder={
                            watch("permanentState")
                              ? "Select District"
                              : "Select State First"
                          }
                          isDisabled={!watch("permanentState")}
                          options={
                            watch("permanentState")
                              ? ECCEDATA.domecile_states[watch("permanentState")].map((d) => ({
                                  value: d,
                                  label: d,
                                }))
                              : []
                          }
                          value={
                            watch("permanentDistrict")
                              ? {
                                  value: watch("permanentDistrict"),
                                  label: watch("permanentDistrict"),
                                }
                              : null
                          }
                          onChange={(selectedOption) => {
                            const selectedDistrict = selectedOption ? selectedOption.value : "";
                            setValue("permanentDistrict", selectedDistrict);
                          }}
                          components={{IndicatorSeparator: () => null }}
                        />
                    {errors.permanentDistrict && <small className="text-danger">{errors.permanentDistrict.message}</small>}
                    </div>

                    <div className="col-md-2">
                        <label className="form-label">PIN Code <span className="text-danger">*</span></label>
                        <input type="text" maxLength={6}  className="form-control" {...register("permanentPin")} />
                        {errors.permanentPin && <small className="text-danger">{errors.permanentPin.message}</small>}
                    </div>

                    {/* <div className="col-md-2">
                        <label className="form-label">City</label>
                        <input type="text" className="form-control" {...register("permanentCity")} />
                    </div>

                    <div className="col-md-2">
                        <label className="form-label">Tehsil</label>
                        <input type="text" className="form-control" {...register("permanentTehsil")} />
                    </div> */}

                    <div className="col-md-4">
                        <label className="form-label">Constituency <span className="text-danger">*</span></label>
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          styles={customSelectStyles}
                          options={Object.keys(ECCEDATA.Stateconstituency).map((state) => ({
                            value: state,
                            label: state,
                          }))}
                          placeholder="Select Constituency"
                          value={
                            watch("permanentConstituency")
                              ? { value: watch("permanentConstituency"), label: watch("permanentConstituency") }
                              : null
                          }
                          onChange={(selectedOption) => {
                            const selectedState = selectedOption ? selectedOption.value : "";
                            setValue("permanentConstituency", selectedState);
                          }}
                          components={{IndicatorSeparator: () => null }}
                        />
                        {errors.permanentConstituency && <small className="text-danger">{errors.permanentConstituency.message}</small>}
                    </div>

                    <div className="col-12">
                        <hr className="my-4" />
                        <h5 className="text-secondary mb-3">Communication Address</h5>
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">Same as Permanent Address <span className="text-danger">*</span></label>
                        <select className="form-select" {...register("communicationSame")}>
                            <option value="">Select</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                        {errors.communicationSame && <small className="text-danger">{errors.communicationSame.message}</small>}
                    </div>

                    {watchCommunicationSame === "No" && (
                    <>
                        

                        <div className="col-md-3">
                        <label className="form-label">State <span className="text-danger">*</span></label>
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          styles={customSelectStyles}
                          options={Object.keys(ECCEDATA.domecile_states).map((state) => ({
                            value: state,
                            label: state,
                          }))}
                          placeholder="Select State"
                          value={
                            watch("communicationState")
                              ? { value: watch("communicationState"), label: watch("communicationState") }
                              : null
                          }
                          onChange={(selectedOption) => {
                            const selectedState = selectedOption ? selectedOption.value : "";
                            setValue("communicationState", selectedState);
                            setValue("communicationDistrict", "");
                          }}
                          components={{IndicatorSeparator: () => null }}
                        />
                        {errors.communicationState && <small className="text-danger">{errors.communicationState.message}</small>}
                        </div>

                        <div className="col-md-3">
                        <label className="form-label">District <span className="text-danger">*</span></label>
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          styles={customSelectStyles}
                          placeholder={
                            watch("communicationState")
                              ? "Select District"
                              : "Select State First"
                          }
                          isDisabled={!watch("communicationState")}
                          options={
                            watch("communicationState")
                              ? ECCEDATA.domecile_states[watch("communicationState")].map((d) => ({
                                  value: d,
                                  label: d,
                                }))
                              : []
                          }
                          value={
                            watch("communicationDistrict")
                              ? {
                                  value: watch("communicationDistrict"),
                                  label: watch("communicationDistrict"),
                                }
                              : null
                          }
                          onChange={(selectedOption) => {
                            const selectedDistrict = selectedOption ? selectedOption.value : "";
                            setValue("communicationDistrict", selectedDistrict);
                          }}
                          components={{IndicatorSeparator: () => null }}
                        />
                        {errors.communicationDistrict && <small className="text-danger">{errors.communicationDistrict.message}</small>}
                        </div>

                        <div className="col-md-3">
                        <label className="form-label">PIN Code <span className="text-danger">*</span></label>
                        <input type="text" maxLength={6} className="form-control" {...register("communicationPin")} />
                        {errors.communicationPin && <small className="text-danger">{errors.communicationPin.message}</small>}
                        </div>

                        {/* <div className="col-md-4">
                        <label className="form-label">City</label>
                        <input type="text" className="form-control" {...register("communicationCity")} />
                        </div>

                        <div className="col-md-4">
                        <label className="form-label">Tehsil</label>
                        <input type="text" className="form-control" {...register("communicationTehsil")} />
                        </div> */}

                        <div className="col-md-4">
                        <label className="form-label">Constituency <span className="text-danger">*</span></label>
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          styles={customSelectStyles}
                          options={Object.keys(ECCEDATA.Stateconstituency).map((state) => ({
                            value: state,
                            label: state,
                          }))}
                          placeholder="Select Constituency"
                          value={
                            watch("communicationConstituency")
                              ? { value: watch("communicationConstituency"), label: watch("communicationConstituency") }
                              : null
                          }
                          onChange={(selectedOption) => {
                            const selectedState = selectedOption ? selectedOption.value : "";
                            setValue("communicationConstituency", selectedState);
                          }}
                          components={{IndicatorSeparator: () => null }}
                        />
                        {errors.communicationConstituency && <small className="text-danger">{errors.communicationConstituency.message}</small>}
                        </div>
                    </>
                    )}
                </div>
                )}

                {/* Step 5: Education & Experience */}
                {currentStep === 4 && (
                <div className="row g-3">
                    <div className="col-md-6">
                    <label className="form-label">Education Level <span className="text-danger">*</span></label>
                    <Select
                        className="basic-single"
                        classNamePrefix="select"
                        styles={customSelectStyles}
                        options={dropdownData.educationLevels.map((state) => ({
                        value: state,
                        label: state,
                        }))}
                        placeholder="Select State"
                        value={{ value: watch("educationLevel"), label: watch("educationLevel") }}
                        onChange={(selectedOption) => {
                        const selectedState = selectedOption ? selectedOption.value : "";
                        setValue("educationLevel", selectedState);
                        }}
                        components={{IndicatorSeparator: () => null }}
                    />
                    {errors.educationLevel && <small className="text-danger">{errors.educationLevel.message}</small>}
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Training Status <span className="text-danger">*</span></label>
                        <select className="form-select" defaultValue="Experienced" {...register("trainingStatus")}>
                            {dropdownData.trainingStatuses.map(t => <option key={t} value={t}>{t}</option>)}
                        </select>
                        {errors.trainingStatus && <small className="text-danger">{errors.trainingStatus.message}</small>}
                    </div>

                    {watchTrainingStatus === "Experienced" && (
                    <>
                        <div className="col-md-6">
                        <label className="form-label">Previous Experience Sector <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" {...register("previousExperienceSector")} />
                        {errors.previousExperienceSector && <small className="text-danger">{errors.previousExperienceSector.message}</small>}
                        </div>

                        <div className="col-md-6">
                            <label className="form-label">
                                No. of Months of Previous Experience <span className="text-danger">*</span>
                            </label>
                            <CreatableSelect
                                isClearable
                                styles={customSelectStyles}
                                options={options}
                                value={selectedOptionmonth}
                                {...register("monthsOfExperience")}
                               
                                // defaultValue={{label:formData?.months_of_experience || null, value: formData?.months_of_experience || null }}
                                onInputChange={handleInputChange}
                                // onChange={handleChange}
                                onChange={(newValue) => {
                                  setSelectedOptionmonth(newValue);
                                  handleChange(newValue);
                                }}
                                placeholder="Enter months"
                                formatCreateLabel={(inputValue) => inputValue}
                            />

                            {errors.monthsOfExperience && (
                                <small className="text-danger">
                                {errors.monthsOfExperience.message}
                                </small>
                            )}
                            {apiError?.months_of_experience?.length > 0 && (
                              <small className="text-danger">{apiError.months_of_experience[0]}</small>
                            )}
                        </div>
                    </>
                    )}
                </div>
                )}

                {/* Step 6: Employment Details */}
                {currentStep === 5 && (
                <div className="row g-3">
                    <div className="col-md-12">
                    <label className="form-label">Employed <span className="text-danger">*</span></label>
                    <select className="form-select" {...register("employed")}>
                        <option value="">Select</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                    {errors.employed && <small className="text-danger">{errors.employed.message}</small>}
                    </div>

                    <div className="col-md-12">
                    <label className="form-label">Employment Status</label>
                    <select className="form-select" {...register("employmentStatus")}>
                        <option value="">Select</option>
                        {dropdownData.employmentStatuses.map(e => <option key={e} value={e}>{e}</option>)}
                    </select>
                    {errors.employmentStatus && <small className="text-danger">{errors.employmentStatus.message}</small>}
                    </div>

                    <div className="col-md-12">
                    <label className="form-label">Employment Details{formData?.employed =='Yes' && <span className="text-danger">*</span>}</label>
                    <textarea className="form-control" rows="3" {...register("employmentDetails")} maxLength="100"></textarea>
                    <small className="text-muted">Maximum 100 characters</small>
                    <br/>
                      {apiError?.employment_details?.length > 0 && (
                          <small className="text-danger">{apiError.employment_details[0]}</small>
                      )}
                    </div>
                </div>
                )}

                {/* Step 7: Other/Documents */}
                {currentStep === 6 && (
                  <div className="row g-3">
                    <div className="col-md-12">
                      <label className="form-label">Heard About Us</label>
                      <select className="form-select" {...register("heardAboutUs")}>
                        <option value="">Select</option>
                        {dropdownData.heardAboutUs.map((h) => (
                          <option key={h} value={h}>
                            {h}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-12">
                      <div className="d-flex justify-content-between mb-2">
                        <label className="form-label">
                          Highest Qualification Marksheet <span className="text-danger">*</span>
                        </label>
                        {formData?.highest_qualification_marksheet ? 
                        <a target="_blank" href={formData?.highest_qualification_marksheet} className="btn btn-sm btn-success">View Marksheet</a>
                        : null
                        }
                      </div>

                      <input
                        type="file"
                        className="form-control"
                        accept=".pdf,.jpg,.jpeg,.png"
                        onChange={async (e) => {
                          const file = e.target.files?.[0];
                          if (file) {
                            const maxSize = 2 * 1024 * 1024;
                            if (file.size > maxSize) {
                              setFileErrors((prev) => ({
                                ...prev,
                                highestQualificationMarksheet: "Marksheet size exceeds 2MB",
                              }));
                              setDocuments((prev) => ({ ...prev, highestQualificationMarksheet: "" }));
                              return;
                            }
                            const base64 = await toBase64(file);
                            setDocuments((prev) => ({
                              ...prev,
                              highestQualificationMarksheet: base64,
                            }));
                            setChangeDoc((prev) => ({
                              ...prev,
                              highestQualificationMarksheet: true,
                            }));
                            setFileErrors((prev) => ({ ...prev, highestQualificationMarksheet: "" }));
                          }
                        }}
                      />
                      <small className="text-muted">PDF/Image (max 2MB)</small>
                      <br />
                      {fileErrors.highestQualificationMarksheet && (
                        <small className="text-danger">{fileErrors.highestQualificationMarksheet}</small>
                      )}
                      {apiError?.highest_qualification_marksheet?.length > 0 && (
                        <small className="text-danger">
                          {apiError.highest_qualification_marksheet[0]
                            ?.replace(/_/g, " ")
                            ?.replace("base64", "")}
                        </small>
                      )}
                    </div>

                    <div className="col-md-12">
                      <div className="d-flex justify-content-between mb-2">
                        <label className="form-label">
                          Aadhaar Card <span className="text-danger">*</span>
                        </label>
                        {formData?.aadhaar_card ? 
                        <a target="_blank" href={formData?.aadhaar_card} className="btn btn-sm btn-success">View Aadhar</a>
                        : null
                        }
                      </div>

                      <input
                        type="file"
                        className="form-control"
                        accept=".pdf,.jpg,.jpeg,.png"
                        onChange={async (e) => {
                          const file = e.target.files?.[0];
                          if (file) {
                            const maxSize = 2 * 1024 * 1024;
                            if (file.size > maxSize) {
                              setFileErrors((prev) => ({
                                ...prev,
                                aadhaarCard: "Aadhaar Card size exceeds 2MB",
                              }));
                              setDocuments((prev) => ({ ...prev, aadhaarCard: "" }));
                              return;
                            }
                            const base64 = await toBase64(file);
                            setDocuments((prev) => ({
                              ...prev,
                              aadhaarCard: base64,
                            }));
                            setChangeDoc((prev) => ({
                              ...prev,
                              aadhaarCard: true,
                            }));
                            setFileErrors((prev) => ({ ...prev, aadhaarCard: "" }));
                          }
                        }}
                      />
                      <small className="text-muted">PDF/Image (max 2MB)</small>
                      <br />
                      {fileErrors.aadhaarCard && <small className="text-danger">{fileErrors.aadhaarCard}</small>}
                      {apiError?.aadhaar_card?.length > 0 && (
                        <small className="text-danger">
                          {apiError.aadhaar_card[0]?.replace(/_/g, " ")?.replace("base64", "")}
                        </small>
                      )}
                    </div>

                    <div className="col-md-12">
                      <div className="d-flex justify-content-between mb-2">
                        <label className="form-label">
                          Photo <span className="text-danger">*</span>
                        </label>
                        {formData?.photo ? 
                        <a target="_blank" href={formData?.photo} className="btn btn-sm btn-success">View Photo</a>
                        : null
                        }
                      </div>

                      <input
                        type="file"
                        className="form-control"
                        accept=".jpg,.jpeg,.png"
                        onChange={async (e) => {
                          const file = e.target.files?.[0];
                          if (file) {
                            const maxSize = 1 * 1024 * 1024;
                            if (file.size > maxSize) {
                              setFileErrors((prev) => ({
                                ...prev,
                                photo: "Photo size exceeds 1MB",
                              }));
                              setDocuments((prev) => ({ ...prev, photo: "" }));
                              return;
                            }
                            const base64 = await toBase64(file);
                            setDocuments((prev) => ({
                              ...prev,
                              photo: base64,
                            }));
                            setChangeDoc((prev) => ({
                              ...prev,
                              photo: true,
                            }));
                            setFileErrors((prev) => ({ ...prev, photo: "" }));
                          }
                        }}
                      />
                      <small className="text-muted">JPG/PNG (max 1MB)</small>
                      <br />
                      {fileErrors.photo && <small className="text-danger">{fileErrors.photo}</small>}
                      {apiError?.photo?.length > 0 && (
                        <small className="text-danger">
                          {apiError.photo[0]?.replace(/_/g, " ")?.replace("base64", "")}
                        </small>
                      )}
                    </div>
                  </div>
                )}

                {/* Navigation Buttons */}
                <div className="d-flex justify-content-between mt-4 pt-3 border-top">
                {currentStep > 0 && (
                    <button type="button" className="btn btn-secondary px-4" onClick={handleBack}>
                    <i className="bi bi-arrow-left me-2"></i>Back
                    </button>
                )}
                {currentStep === 0 && <div></div>}
                <button type="submit" className="btn btn-primary px-4 btn-lg">
                    {loadingStep ?
                    <>
                        <div className="spinner-border spinner-border-sm text-light pr-1" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                        {" "}Please Wait
                    </> 
                        : <>
                        {currentStep === steps.length - 1 ? (
                        <>Submit <i className="bi bi-check-circle ms-2"></i></>
                        ) : (
                        <>Next <i className="bi bi-arrow-right ms-2"></i></>
                        )}
                    </>}
                </button>
                </div>
            </form>
            </div>
        </div>
        <style>
          {`
          @media (max-width: 768px) {
            .step-scroll-container {
              overflow-x: auto;
              white-space: nowrap;
              scrollbar-width: thin; 
              scroll-behavior: smooth; 
            }

            .step-scroll-container .d-flex {
              flex-wrap: nowrap !important;
            }
            
            .step-scroll-container::-webkit-scrollbar {
              height: 4px;   /* Change this value to increase/decrease scrollbar thickness */
            }

            .step-scroll-container::-webkit-scrollbar-track {
              background: #f1f1f1;
            }

            .step-scroll-container::-webkit-scrollbar-thumb {
              background: #bdbdbd;
              border-radius: 10px;
            }
          }
          .react-datepicker-wrapper{
              display: block;
              width: 100%;
            }
            .datepickerheight{
              height:37px;
              color:#6d6e72;
              font-size:14px;
          }
          `}
        </style>
    </div>
  );
};

export default ECCAMultiStepForm;